import "./ArchiveProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import PageTitleAndBreadcrumbsSection from "./sections/PageTitleAndBreadcrumbsSection"
import ProductGridAndPaginationSection from "./sections/ProductGridAndPaginationSection"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Header />
      <PageTitleAndBreadcrumbsSection />
      <ProductGridAndPaginationSection />
      <Footer />
    </div>
  )
}
